import React, { useEffect, useState } from "react";
import {
  SAAlert,
  SAButton,
  SAIcon,
  SAIcons,
  SAIconSize,
} from "@saux/design-system-react";
import imageDesign from "./ImageViewer.module.css";
import styled from "styled-components";
import {
  Grid,
  Hidden,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { Modal } from "../../styles/Modal.style";
import Button from "@mui/material/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { loader } from "graphql.macro";
import { useDispatch, useSelector } from "react-redux";
import { executeGraphqlMutation } from "../../graphql/api";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { EXPORT_LOCATION, SNACKBAR } from "../../utils/constants";
import { useLocation } from "react-router-dom";
import { CUSTOMER } from "../../utils/constants";
import alertOpen from "../../store/action-creators/alertActionCreator";
import { simpleGTMDataLayer } from "../../utils/utilities";

const createPDF = loader("../../graphql/mutations/photoPDFGenerator.graphql");

const Template = styled.div`
  width: 42rem;
  padding-right : 20rem;
  height: 35rem !important;
  @media (max-width: 768px) {
    width: 20rem;
    height: 23rem !important;
  }
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  margin: 2vh auto;
  .template-header {
    display: flex;
  }
  .message-category {
    margin-top: 20px;
    .heading {
      font-size: 16px;
      font-family:Lato !important;;
    }
    .automated-message {
      display: flex;
      margin-top: 10px;
      img {
        cursor: pointer;
      }
      .text {
        font-size: 12px;
        font-family:Lato;
        margin: auto 12px;
      }
    }
  }
`;
const HeadingTab = styled.div`
  height: 2em !important;
`;

const GalleryButton = styled(SAButton)`
 font-family:Lato;
 line-height:16px;
`;

const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 10px;
  padding-right:40px !important;
  gap: 10px;
`;
const LoaderModal = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;

const ImageModal = styled(Modal)`
  height: 100vh;
`;

const ImageSection = styled.img`
  height: 25.95rem;
  width: 34.6rem;
  @media (max-width: 768px) {
    width: 10rem;
  }

  left: 9%;
  position: relative;
  object-fit:contain;
`;

interface ImageData {
  conversationId: string;
  contentType: string;
  message: string;
  createdTimestamp: string;
  messageId: string;
}

interface ImageViwerProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  imageData: ImageData[];
  uniqueData: string[];
  imageId?: string;
  preview?: boolean;
}

interface ICompleteExport {
  exportLocal: boolean;
  exportCC: boolean;
}

export default function ImageViewer(props: ImageViwerProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  const dispatch = useDispatch();
  const [spinner, setSpinner] = useState(false);
  const [pdfUrl, setpdfUrl] = useState("");
  const [completeExport, setCompleteExport] = useState<ICompleteExport>({
    exportLocal: false,
    exportCC: false,
  });
  const [pdfLoader, setPdfLoader] = useState(false);
  const [preview, setPreview] = useState(false);
  const [currentImage, setCurrentImage] = useState(1);
  const [selectedImg, setSelectedImg] = useState<ImageData[]>([]);
  const [exportFlag, setExportFlag] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const user = useSelector((state: any) => state.user);

  const isChecked = () => {
    return Object.values(completeExport).find((x) => x == true) ? true : false;
  };

  const graphQLMutation = (exportVariable: any) => {
    setPdfLoader(true);
    executeGraphqlMutation(createPDF, exportVariable)
      .then((res: any) => {
        if (
          res.data.generatePhotoPdf &&
          res.data.generatePhotoPdf.status == "success"
        ) {
          if(exportVariable.exportLocal && exportVariable.exportCC)
          {
            setpdfUrl(res.data.generatePhotoPdf.downloadLink);
            setPdfLoader(false);
            dispatch(
              alertOpen({
                open: true,
                message: "PDF is ready for download and a copy has been sent to ClaimCenter",
                action: "DOWNLOAD",
                url:res.data.generatePhotoPdf.downloadLink,
              })
            );            
            props.setDialogOpen(false);
 
          }
          else if (exportVariable.exportLocal) {
            setpdfUrl(res.data.generatePhotoPdf.downloadLink);
            setPdfLoader(false);
            dispatch(
              alertOpen({
                open: true,
                message: "PDF Ready",
                action: "DOWNLOAD",
                url:res.data.generatePhotoPdf.downloadLink,
              })
            );            
            props.setDialogOpen(false);
          }
          else {
            setPdfLoader(false);
            dispatch(
              snackbarOpen({
                open: true,
                message: "PDF document uploaded successfully to ClaimCenter",
                type: SNACKBAR.SUCCESS,
              })
            );
            props.setDialogOpen(false);
          }
        } else {
          throw Error;
        }
      })
      .catch((error: any) => {
        setPdfLoader(false);

        dispatch(
          snackbarOpen({
            open: true,
            message: "Error occured while processing pdf",
            type: SNACKBAR.ERROR,
          })
        );

        props.setDialogOpen(false);
      });
  };
  const completeExportCall = () => {
    const imageDetails = selectedImg.map((image) => ({
      imageURL: image.message,
      timeStamp: image.createdTimestamp,
      imageType: image.contentType.replace("image/", ""),
    }));
    const exportVariable = {
      claimNumber,
      contactName: customer.name,
      phoneNumber: customer.phoneNumber,
      conversationId,
      imageDetails,
      exportLocal: completeExport.exportLocal,
      exportCC: completeExport.exportCC,
    };

    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Complete-Export-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Complete Export selected photo gallery images`,
      event_value: `${user.fullName} clicked 'COMPLETE EXPORT' to export selected images from photo gallery.`,
      claim_number: claimNumber
  });
  simpleGTMDataLayer({
      csrId: user.userName,
      event: `Complete-Export-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Complete Export selected photo gallery images`,
      event_value: `${user.fullName} clicked 'COMPLETE EXPORT' to export selected images from photo gallery.`,
      claim_number: claimNumber
    });

    isChecked()
      ? graphQLMutation(exportVariable)
      : dispatch(
          snackbarOpen({
            open: true,
            message: EXPORT_LOCATION,
            type: SNACKBAR.ERROR,
          })
        );
  };

  const selectedConversation = useSelector(
    (state: any) => state.chat.selectedConversation
  );

  const modalOnClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  let location = useLocation();
  let customer =
    selectedConversation?.participants &&
    selectedConversation?.participants.find(
      (con: any) => con.participantType === CUSTOMER
    );
  const claimNumber = selectedConversation?.claimNumber;
  const query = new URLSearchParams(location.search);
  const conversationId = query.get("id");

  const setImages = (e: any, imgData: ImageData) => {
    if (e.target.checked) {
      setSelectedImg([...selectedImg, imgData]);
    } else {
      let filteredArray = selectedImg.filter(
        (item) => item.messageId !== imgData.messageId
      );
      setSelectedImg(filteredArray);
    }
  };

  const setSelectAllImages = (e: any) => {
    if (e.target.checked) {
      setSelectAll(true);
      setSelectedImg(props.imageData);
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Select-All-Checkbox-Click`,
        event_action: 'Checkbox Click',
        event_category: window.location.pathname,
        event_label: `User should select all images from photo gallery.`,
        event_value: `${user.fullName} has ${e.target.checked ? "checked" : "unchecked"} the 'Select All' checkbox.`,
        claim_number: claimNumber
    });
    simpleGTMDataLayer({
        csrId: user.userName,
        event: `Select-All-Checkbox-Click-Snowplow`,
        event_action: 'Checkbox Click',
        event_category: window.location.pathname + "/Snowplow",
        event_label: `User should select all images from photo gallery.`,
        event_value: `${user.fullName} has ${e.target.checked ? "checked" : "unchecked"} the 'Select All' checkbox.`,
        claim_number: claimNumber
    });
    } else {
      setSelectAll(false);
      setSelectedImg([]);
    }
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dateFormatter = (dateVal: string) => {
    return `${monthNames[parseInt(dateVal.slice(6, 8)) - 1]} ${dateVal.slice(
      8,
      10
    )}, ${dateVal.slice(0, 4)}`;
  };

  // const timeConvert  = (time) => {

  //   if (time.length > 1) {
  //     time = time.slice (1);
  //     time[5] = +time[0] < 12 ? 'AM' : 'PM';
  //     time[0] = +time[0] % 12 || 12;
  //   }
  //   return time.join ('');
  // }

  const previewMode = (item: ImageData) => {
    setPreview(true);
    setCurrentImage(
      props.imageData.findIndex(
        (element) => element.messageId == item.messageId
      ) + 1
    );
  };

  const exportLocal=(e: any) => {
    const checkbox: boolean = e.target.checked;
    setCompleteExport({
      ...completeExport,
      exportLocal: checkbox,
    });
    simpleGTMDataLayer({
        csrId: user.userName,
        event: `Export-Local-Checkbox-Click`,
        event_action: 'Checkbox Click',
        event_category: window.location.pathname,
        event_label: `User should export selected images as pdf from photo gallery to local.`,
        event_value: `${user.fullName} has ${e.target.checked ? "checked" : "unchecked"} the 'Export Local' checkbox.`,
        claim_number: claimNumber
       });
    simpleGTMDataLayer({
        csrId: user.userName,
        event: `Export-Local-Checkbox-Click-Snowplow`,
        event_action: 'Checkbox Click',
        event_category: window.location.pathname + "/Snowplow",
        event_label: `User should export selected images as pdf from photo gallery to local.`,
        event_value: `${user.fullName} has ${e.target.checked ? "checked" : "unchecked"} the 'Export Local' checkbox.`,
        claim_number: claimNumber
    });
  }

  const exportClaimCenter =(e: any) => {
    const checkbox: boolean = e.target.checked;
    setCompleteExport({
      ...completeExport,
      exportCC: checkbox,
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Export-To-ClaimCenter-Checkbox-Click`,
      event_action: 'Checkbox Click',
      event_category: window.location.pathname,
      event_label: `User should export selected images as pdf from photo gallery to claim center.`,
      event_value: `${user.fullName} has ${e.target.checked ? "checked" : "unchecked"} the 'Export to ClaimCenter' checkbox.`,
      claim_number: claimNumber
  });
  simpleGTMDataLayer({
      csrId: user.userName,
      event: `Export-To-ClaimCenter-Checkbox-Click-Snowplow`,
      event_action: 'Checkbox Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `User should export selected images as pdf from photo gallery to claim center.`,
      event_value: `${user.fullName} has ${e.target.checked ? "checked" : "unchecked"} the 'Export to ClaimCenter' checkbox.`,
      claim_number: claimNumber
  });
  }

  const imageListMap = (e: string) => {
    return props.imageData
      .filter((x) => x.createdTimestamp.slice(0, 10) == e)
      .map((item) => (
        // <ImageListItem className={imageDesign.container} key={item?.messageId}>
        <div className={imageDesign.container} key={item?.messageId}>
          <img
            src={`${item.message}`}
            srcSet={`${item.message}?dpr=2 2x`}
            loading="lazy"
            alt={item?.message}
            style={{ 
              height: "9em", width:"9em", 
              backgroundColor:"rgb(22 20 20 / 78%)" ,
              objectFit:"contain"
             // padding:"10px"
           }}
          />
          <div className={imageDesign.overlay}>
            {/* <img
              src={search}
              alt="#"
              width={20}
              height={20}
              className={imageDesign.images}
              onClick={() => previewMode(item)}
            ></img> */}
            <SAIcon
              icon={SAIcons.search}
              className={imageDesign.images}
              size={SAIconSize.medium}
              onClick={() => previewMode(item)}
              colorVariant="tertiary"
            />
          </div>

          <input
            type="checkbox"
            id="scales"
            name="scales"
            checked={selectedImg.some(
              (element) => element.messageId == item.messageId
            )}
            onClick={(e) => setImages(e, item)}
            style={
              isMobile
                ? {
                    position: "absolute",
                    top: "5%",
                    left: "5%",
                    width: "1em",
                    height: "1em",
                  }
                : {
                    position: "absolute",
                    top: "5%",
                    left: "5%",
                    width: "2em",
                    height: "2em",
                  }
            }
          />
          </div>
      ));
  };

  useEffect(() => {
    props.preview && setPreview(true);
    try {
      setCurrentImage(
        props.imageData.findIndex(
          (element: ImageData) => element.messageId == props.imageId
        ) + 1
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <>
      {spinner && (
        <LoaderModal>
          <Grid container alignItems="center" style={{ height: "80vh" }}>
            <Grid
              container
              justify="flex-end"
              direction="row"
              alignItems="center"
            >
              <Grid item xs={12}>
                <div className="loader" />
              </Grid>
            </Grid>
          </Grid>
        </LoaderModal>
      )}

        <ImageModal
          data-testid="automated-message-modal"
          onClickHandler={(event: React.MouseEvent) =>
            modalOnClickHandler(event)
          }
        >
          {pdfLoader ? (
            <Template>
              <div className="template-header">
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                    fontFamily:"Lato"
                  }}
                >
                  {preview ? "Photo Preview" : "Photo Gallery"}-{" "}
                  {customer?.name}
                </div>
              </div>

              <Grid container spacing={3} xs={12} md={12} justify="flex-start">
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>

                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>
                <Hidden xsDown>
                  <Grid item sm={5} />
                </Hidden>

                <Grid item sm={1}>
                  <SaveIcon
                    color={"primary"}
                    style={{ width: 80, height: 80 }}
                  />
                </Grid>
                <Hidden xsDown>
                  <Grid item sm={6} />
                </Hidden>

                <Grid item sm={12}>
                  <div
                    style={{
                      fontSize: 24,
                      display: "flex",
                      justifyContent: "center",
                      fontFamily:"Lato",
                      lineHeight:"27.65px",
                    }}
                  >
                    Building Photos into PDF
                  </div>
                </Grid>

                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>

                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>

                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>

                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>

                <Hidden xsDown>
                  <Grid item sm={12} />
                </Hidden>

                <Hidden xsDown>
                  <Grid item sm={7} />
                </Hidden>
                <Grid item sm={2}>
                  <SAButton
                    color="black"
                    label="Close"
                    onClick={(e) => setPdfLoader(false)}
                    variant="link-medium"
                  />
                </Grid>
                <Grid item sm={2}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      pointerEvents: "none",
                    }}
                  >
                    <CircularProgress
                      style={{
                        marginLeft: 0,
                        marginRight: "0.5em",
                        color: "white",
                      }}
                      size={16}
                    />
                    EXPORTING
                  </Button>
                </Grid>

                <Hidden xsDown>
                  <Grid item sm={1} />
                </Hidden>
              </Grid>
            </Template>
          ) : (
            <Template>
              {preview ? (
                <>
                  <div className="template-header">
                    <div style={{ fontWeight: "bold", fontSize: 20, fontFamily:"Lato" }}>
                      Photo Preview - {customer?.name}
                    </div>
                  </div>
                  <br />
                  <div className={imageDesign.containerGallery}>
                    {props.imageData[0] &&
                      props.imageData.map(
                        (item: ImageData) =>
                          currentImage ==
                            props.imageData.findIndex(
                              (element: ImageData) =>
                                element.messageId == item.messageId
                            ) +
                              1 && (
                            <div
                              key={item.messageId}
                              className={imageDesign.mySlides}
                            >
                              
                              <ImageSection src={item.message} />
                              <input
                                type="checkbox"
                                id="scales"
                                name="scales"
                                checked={selectedImg.some(
                                  (element) =>
                                    element.messageId == item.messageId
                                )}
                                onClick={(e) => setImages(e, item)}
                                style={
                                  isMobile
                                    ? {
                                        position: "absolute",
                                        top: "5%",
                                        left: "2%",
                                        width: "1em",
                                        height: "1em",
                                      }
                                    : {
                                        position: "absolute",
                                        top: "5%",
                                        left: "2%",
                                        width: "2em",
                                        height: "2em",
                                      }
                                }
                              />
                              <div
                                style={
                                  isMobile
                                    ? {
                                        position: "absolute",
                                        top: "5%",
                                        right: "2%",
                                      }
                                    : {
                                        position: "absolute",
                                        top: "5%",
                                        right: "2%",
                                      }
                                }
                                data-testid="close"
                              >
                                <SAButton
                                  label="Adjuster"
                                  onClick={() => setPreview(false)}
                                  textTransform="uppercase"
                                  variant="link-medium"
                                  style={{
                                    backgroundColor: "white",
                                    height: "27px",
                                    padding: "8px",
                                  }}
                                >
                                  <SAIcon
                                    icon={SAIcons.x}
                                    colorVariant={"#3B3B3B"}
                                    size={SAIconSize.small}
                                  ></SAIcon>
                                </SAButton>
                              </div>{" "}
                            </div>
                          )
                      )}
                  <div className={imageDesign.prevnextparent}>
                    <a
                      className={imageDesign.prev}
                      onClick={() => {
                        currentImage === 1
                          ? setCurrentImage(props.imageData.length)
                          : setCurrentImage(currentImage - 1);
                      }}
                    >
                      <SAIcon style = {{position:'relative' , bottom:"85%"}} icon={SAIcons.chevronLeft} size={SAIconSize.medium} colorVariant="#666666" />
                    </a>
                    <div className={imageDesign.numbertext}>
                                {currentImage} / {props.imageData.length}
                              </div>
                    <a
                      className={imageDesign.next}
                      onClick={() => {
                        currentImage === props.imageData.length
                          ? setCurrentImage(1)
                          : setCurrentImage(currentImage + 1);
                      }}
                    >
                      <SAIcon style = {{position:'relative' , bottom:"85%"}} icon={SAIcons.chevronRight} size={SAIconSize.medium} colorVariant="#666666" />
                    </a>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="template-header">
                    <div style={{ fontWeight: "bold", fontSize: 20, fontFamily:"Lato" }}>
                      Photo Gallery - {customer?.name}
                    </div>
                  </div>
                  <br />

                    <div style={{width: 700, height: 400,overflowY: "scroll"}}>
                    {props.uniqueData.map((date: string) => (
                      <>
                        <HeadingTab key="Subheader">
                          <div style={{ marginTop: "2em", fontWeight: 10,paddingRight:"10px" ,fontFamily:"Lato",fontSize:"13.33px",lineHeight:"16px"}}>
                            {dateFormatter(date)}
                            <hr />
                          </div>
                        </HeadingTab>

                        <Columns
        // style={
        // isMobile
        //   ? { width: 300, height: 300, paddingRight: "30px"   }
        //   : { width: 700, height: 400, paddingRight: "30px"  }}
      >
                        {imageListMap(date)}
                        </Columns>
                      </>
                    ))}
                    </div>
                  <br />
                </>
              )}
              {exportFlag ? (
                <>
                  <div style={{ marginTop: "2em", marginLeft: "0.3em",marginBottom:"1em",lineHeight:"16px",fontFamily:"Lato",fontSize:"13.33px" }}>
                    {selectedImg.length}{" "}
                    {selectedImg.length == 1 ? "Image" : "Images"} Selected
                  </div>

                  <div
                    style={{ display: "flex", justifyContent: "space-around",alignItems:"center" }}
                  >
                    <input
                      type="checkbox"
                      id="scales"
                      name="scales"
                      style={
                        isMobile
                          ? { width: "1em", height: "1em" }
                          : { width: "2em", height: "2em" }
                      }
                      onClick={(e: any) => exportLocal(e)}
                    />

                    <div style={{ marginRight: "2em",lineHeight:"20.8px",fontFamily:"Lato",fontSize:"16px" }}>
                      Export Local
                    </div>
                    <input
                      type="checkbox"
                      id="scales"
                      name="scales"
                      style={
                        isMobile
                          ? { width: "1em", height: "1em"}
                          : { width: "2em", height: "2em"}
                      }
                      onClick={(e: any) => exportClaimCenter(e)}
                    />
                    <div style={{ marginRight: "2em", lineHeight:"20.8px",fontFamily:"Lato",fontSize:"16px" }}>
                      Export to ClaimCenter
                    </div>
                    <GalleryButton
                      color="black"
                      label="Cancel"
                      onClick={() => setExportFlag(false)}
                      variant="link-medium"
                    />

                    <GalleryButton
                      fullWidth={false}
                      color="secondary"
                      label="Complete Export"
                      variant="medium"
                      onClick={completeExportCall}
                    />
                  </div>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "3.4em",
                    alignItems:"center"
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <input
                      type="checkbox"
                      id="scales"
                      name="scales"
                      checked={selectAll}
                      onClick={(e) => setSelectAllImages(e)}
                      style={
                        isMobile
                          ? {
                              width: "1em",
                              height: "1em",
                            }
                          : {
                              width: "2em",
                              height: "2em",
                            }
                      }
                    />
                    <div style={{ marginTop: "0.5em", marginLeft: "0.5em", 
                    fontFamily:"Lato" ,lineHeight:"20.8px",fontSize:"16px"}}>
                      Select All
                    </div>
                  </div>
                  <div style={{ fontFamily:"Lato",fontSize:"16px" }}>
                    {selectedImg.length}{" "}
                    {selectedImg.length == 1 ? "Image" : "Images"} Selected
                  </div>
                  <div style={{ display: "flex",fontFamily:"Lato" }}>
                    <GalleryButton
                      color="black"
                      label="Close"
                      onClick={() => props.setDialogOpen(false)}
                      variant="link-medium"
                    />

                    <GalleryButton
                      color="secondary"
                      label="Export PDF"
                      disabled={selectedImg.length == 0}
                      onClick={() => setExportFlag(true)}
                      variant="medium"
                    />
                  </div>
                </div>
              )}
            </Template>
          )}
        </ImageModal>
      
    </>
  );
}
